import { Row, Table, Col, Card, Select, Popover } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  CardTitleText,
  MenuItemText,
  StandardTableRowText,
  TableColumnTitle,
} from '../../../../../../../shared/globalStyling/styledText';
import { formatNumber, formatNumber2SigFig } from '../../../../../../../../core/utils/campaigns';
import CampaignsDonut from './CampaignsDonut';
import { randomColors } from '../../../../../../../../core/utils/colors';

const { Option } = Select;

const Style = {
  campaignCardStyle: {
    margin: 5,
    padding: 2,
    height: 340,
    backgroundColor: '#fff',
  },
  campaignCardStyleCreatives: {
    backgroundColor: '#fff',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 24,
    offset: 0,
  },
  md: {
    span: 16,
    offset: 0,
  },
  lg: {
    span: 16,
    offset: 0,
  },
  xl: {
    span: 16,
    offset: 0,
  },
  xsPie: {
    span: 24,
    offset: 0,
  },
  smPie: {
    span: 24,
    offset: 0,
  },
  mdPie: {
    span: 8,
    offset: 0,
  },
  lgPie: {
    span: 8,
    offset: 0,
  },
  xlPie: {
    span: 8,
    offset: 0,
  },
};

const {
  xs,
  sm,
  md,
  lg,
  xl,
  xsPie,
  smPie,
  mdPie,
  lgPie,
  xlPie,
  campaignCardStyle,
  campaignCardStyleCreatives,
} = Style;

const options = [
  {
    value: 'impressions',
    text: 'Ad Impressions',
  },
  {
    value: 'clicks',
    text: 'Clicks',
  },
];
const Extra = ({ setCampaignsDimenstion }) => {
  return (
    <Row gutter={[10, 0]} justify="space-between" align="bottom">
      <Col>
        <CardTitleText text={'Breakdown'} />
      </Col>
      <Col>
        <Row align="bottom">
          <TableColumnTitle text={'Show By:'} />
          <Select
            defaultValue={options[0].value}
            onChange={(value) => {
              setCampaignsDimenstion(value);
            }}
          >
            {options.map((option, index) => {
              return (
                <Option key={index} value={option.value}>
                  <MenuItemText text={option.text} />
                </Option>
              );
            })}
          </Select>
        </Row>
      </Col>
    </Row>
  );
};

const CampaignsCard = ({ data }) => {
  const [campaignsDimenstion, setCampaignsDimenstion] = useState('impressions');
  const [filteredData, setFilteredData] = useState(data);

  useEffect(() => {
    if (data && data.length > 0) {
      const filtered = data.filter((item) => item.name);
      setFilteredData(filtered);
    } else {
      setFilteredData([]);
    }
  }, [data]);

  const columns = [
    {
      title: <TableColumnTitle text={'Name'} />,
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      width: '35%',
      render: (name) => (
        <Popover trigger="hover" title={name}>
          <StandardTableRowText text={name} />
        </Popover>
      ),
    },
    {
      title: <TableColumnTitle text={'Flight Dates'} />,
      dataIndex: 'lineItemName',
      key: 'lineItemName',
      align: 'left',
      width: '20%',
      render: (_, record) => {
        return <StandardTableRowText text={`${record.startDate} - ${record.endDate}`} length={6} />;
      },
    },
    {
      title: <TableColumnTitle text={'Impressions'} />,
      dataIndex: 'impressions',
      key: 'impressions',
      align: 'left',
      width: '15%',
      render: (impressions) => <StandardTableRowText text={formatNumber(impressions)} />,
    },
    {
      title: <TableColumnTitle text={'Clicks'} />,
      dataIndex: 'clicks',
      key: 'clicks',
      align: 'left',
      width: '10%',
      render: (clicks) => <StandardTableRowText text={formatNumber(clicks)} />,
    },
    {
      title: <TableColumnTitle text={'CTR'} />,
      dataIndex: 'ctr',
      key: 'ctr',
      align: 'left',
      width: '10%',
      render: (ctr) => <StandardTableRowText text={formatNumber2SigFig(ctr) + `%`} />,
    },
  ];
  return (
    <Row gutter={35}>
      <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
        <Card
          style={campaignCardStyleCreatives}
          headStyle={{ borderWidth: '3px', height: '66px' }}
          bodyStyle={{ padding: 0 }}
          title={<CardTitleText text={'Campaigns'} />}
        >
          <Table columns={columns} dataSource={filteredData} scroll={{ x: 200, y: 400 }} />
        </Card>
      </Col>
      <Col xs={xsPie} sm={smPie} md={mdPie} lg={lgPie} xl={xlPie}>
        <Card
          style={campaignCardStyleCreatives}
          bodyStyle={{ padding: 0, height: '100%' }}
          headStyle={{ borderWidth: '2px' }}
          title={<Extra setCampaignsDimenstion={setCampaignsDimenstion} />}
        >
          <CampaignsDonut
            data={filteredData.map((d) => ({
              ...d,
              value: d.name,
              color: randomColors(),
            }))}
            height={campaignCardStyle.height}
            selectedDimension={campaignsDimenstion}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default CampaignsCard;
